<template>
  <template
    v-for="{ section, items, type } in groupedSections"
    :key="section?.sys.id ?? items[0].sys.id"
  >
    <MappedComponents
      v-if="asSection || type === 'sectionItemEntry'"
      :items="items"
    />
    <ContentfulContentSection v-else :section="section" :items="items" />
  </template>
</template>

<script setup lang="ts">
import type { Entry } from 'contentful';
import { groupSections } from '~~/utils/groupSections';
import { isDefined } from '~/utils/guards/isDefined';
import { isEntryNotAvailableInLanguageError } from '~/utils/guards/isEntryNotAvailableInLanguageError';

interface Props {
  // if an entry was deleted but is still referenced, contentful returns
  // `undefined`.
  // @see https://gcp.baslerweb.com/jira/browse/WEB2-2536
  entries: (Entry<unknown> | undefined)[];
  asSection?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  asSection: false
});

const groupedSections = computed(() =>
  groupSections(
    props.entries.filter(
      (item) => isDefined(item) && !isEntryNotAvailableInLanguageError(item)
    ) as Entry<unknown>[]
  )
);
</script>
